import classNames from 'classnames';
import { useEffect } from 'react';
import styles from './InfoTable.module.scss';

const Table = ({ data, className }) => {
  useEffect(() => {
    const allWithClass = Array.from(
      document.querySelectorAll('.InfoTable_table__element__HelTx'),
    );

    allWithClass.forEach((element, index) => {
      if (index % 2 !== 0) element.classList.add(styles.gray);
    });
  }, []);

  const renderTableItem = (item, index) => {
    return (
      <div className={styles.table__element} key={index}>
        {item?.text}
      </div>
    );
  };

  const renderTableRow = (item, index) => {
    return (
      <div className={styles.table__column} key={index}>
        <strong className={styles.table__title}>{item.title}</strong>
        <div className={styles.table__values}>
          {item.values.map(renderTableItem)}
        </div>
      </div>
    );
  };

  return (
    <div className={classNames(styles.table, className)}>
      <div className={styles.table__inner}>{data.map(renderTableRow)}</div>
    </div>
  );
};

export default Table;
